import { useMutation } from '@tanstack/react-query'
import { useLoginUser } from 'Features/auth/hooks/login'
import { LoginParamsType } from 'Types/LoginParams'
import { googleSsoLogin } from './loginCall'
import { useNavigate } from 'react-router-dom'
import { AFTER_TRIAL_SUBSCRIPTION_STATUSES } from 'Consts/afterTrialsubscriptionStatuses'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { GLOBAL_MODALS } from 'Types/GlobalModal'

type UseGoogleLoginProps = {
  onError: (error: any) => void
}

export const useGoogleLogin = ({ onError }: UseGoogleLoginProps) => {
  const { login } = useLoginUser()
  const navigate = useNavigate()
  const { setModalToShow } = useAppStore()
  return useMutation(googleSsoLogin, {
    onError: (error) => {
      onError(error)
    },
    onSuccess: (response) => {
      const loginParams: LoginParamsType = {
        token: response.data.token,
        userId: response.data.userId,
        defaultAccount: response.data.defaultAccount,
        authCode: response.data.authCode,
        subscriptionId: response.data.subscriptionId,
        language: response.data.language,
        multiAccount: response.data.multiAccount,
        neverSubscribed: response.data.neverSubscribed,
      }
      login(loginParams)

      if (
        !loginParams.multiAccount &&
        !loginParams.defaultAccount.activeSubscription &&
        !loginParams.neverSubscribed
      ) {
        navigate('/reactivation')
        return
      } else if (!loginParams.subscriptionId && loginParams.neverSubscribed) {
        navigate('/pricing')
      } else {
        navigate('/')
      }

      // if no credit card and trial ended - show payment method modal
      if (
        AFTER_TRIAL_SUBSCRIPTION_STATUSES.includes(response.data.defaultAccount.status) &&
        response.data.defaultAccount.noCreditCardSubscription
      ) {
        setModalToShow(GLOBAL_MODALS.TRIAL_ENDED)
      }
      return response
    },
  })
}
